export default __webpack_public_path__ + "static/media/samples.3fa262ec.svg";